module.exports = __webpack_public_path__ + "img/open-result-icon-step-02.d2363a64.png";